export const isUserHasRole = (profileRoles: string[], roles: string[]): boolean => {
    return roles.includes(profileRoles[0]);
};
